<template>
  <div class="bindPhone">
    <Navbar title="换绑手机号" :default-bg="false" :service="true"/>
    <div class="cart-box">
      <div class="cart">
        <div class="describe">
          <span>已绑定手机号：{{ phone }}</span>
        </div>
        <div class="describe">
          <input type="text" placeholder="请输入图片验证码" v-model="code"
                 @input="changeInputVal($event,/^[^\d]+/g,'code',0,4)"/>
          <img :src="verifyCodeImg" alt="" @click="getImgVerifyCode">
        </div>
        <div class="describe">
          <input type="text" placeholder="请输入手机验证码" v-model="verifyCode"
                 @input="changeInputVal($event,/^[^\d]+/g,'verifyCode',0,6)"/>
          <verifyButton :type="1" :code="code" :token="token" :judge-phone="false" @resetImgVerifyCode="getImgVerifyCode"/>
        </div>
      </div>
    </div>
    <div class="next">
      <button class="themeColor" @click="submitCode">下一步</button>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import verifyButton from "../../components/verifyButton";
import {mixins} from "../../mixins";
import {Toast} from "vant";

export default {
  name: "bindPhoneStep1",
  components: {Navbar, verifyButton},
  mixins: [mixins],
  data() {
    return {
      verifyCodeImg: "",
      code: null,
      token: '',
      phone: '',
      verifyCode: null,//手机验证码
    }
  },
  created() {
    this.getUserInfo();
    this.getImgVerifyCode();
  },
  methods: {
    changeInputVal(e, reg, key, min = 0, max) {
      this[key] = e.target.value.replace(reg, '').slice(min, max);
    },
    toPages() {
      this.$router.push('/my/bindPhoneStep2');
    },
    //提交验证码
    submitCode() {
      // this.toPages();
      if (!this.verifyCode) {
        return Toast('请输入手机验证码');
      }
      let data = {
        code: this.verifyCode,
        smsToken: sessionStorage.getItem('smsToken')
      }
      this.$post('user/modify', data).then(result => {
        if (result.status === 200) {
          this.toPages();
        } else {
          this.getVerifyCode();
          return Toast(result.msg);
        }
      });
    },
    //获取用户信息
    getUserInfo() {
      this.$post('user/info').then(result => {
        this.phone = result.data.userMobile;
      });
    }
  }
}
</script>

<style scoped lang="less">
.bindPhone {
  font-size: 14px;

  .cart-box {
    margin-top: 20px;
    padding: 0 15px;
    box-sizing: border-box;

    .cart {
      background: #FFFFFF;
      border-radius: 8px;
      padding: 0 20px;
      box-sizing: border-box;

      .describe:last-child {
        border-bottom: none;
      }

      .describe {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #EEEEEE;

        input {
          font-size: 15px;
          border: none;
          text-align: left;
          padding: 0;
        }

        img {
          width: 100px;
          height: 35px;
        }

        button {
          color: #126AFC;
          font-size: 15px;
          border: none;
          background: transparent;
        }
      }
    }
  }

  .next {
    margin-top: 70px;
    padding: 0 15px;

    button {
      width: 100%;
      height: 50px;
      border-radius: 25px;
      border: none;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>